import { render, staticRenderFns } from "./propertiesModal.vue?vue&type=template&id=531a0d07"
import script from "./propertiesModal.vue?vue&type=script&lang=js"
export * from "./propertiesModal.vue?vue&type=script&lang=js"
import style0 from "./propertiesModal.vue?vue&type=style&index=0&id=531a0d07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports